<cre-idle-dialog></cre-idle-dialog>
<ng-container *ngIf="authService.isAuthenticated()">
  <app-navbar></app-navbar>
  <app-header></app-header>
  <cre-notification></cre-notification>
  <router-outlet></router-outlet>
</ng-container>
